import { getScopedActionCode, getScopedActivityEntryCode } from '@features/entity/types/actionCodes';
import { activitySubmitPath, departmentReportsDraftPath, invitesPath } from './dashboardPaths';

export interface LocalDashboardAction {
  key: string;
  label: string;
  actionCode: string;
  path: string;
}

export function buildQuickActions(
  scope: string,
  scopeId: number,
  permittedActions: string[]
): LocalDashboardAction[] {
  const actions: LocalDashboardAction[] = [];
  const permitted = new Set(permittedActions);

  const saveActivityCode = getScopedActivityEntryCode(scope, 'save');
  if (saveActivityCode && permitted.has(saveActivityCode)) {
    actions.push({
      key: 'new-activity',
      label: 'New Activity Submission',
      actionCode: saveActivityCode,
      path: activitySubmitPath(scope, scopeId),
    });
  }

  const saveReport = getScopedActionCode(scope, 'SAVE_REPORT');
  if (permitted.has(saveReport)) {
    actions.push({
      key: 'department-reports',
      label: 'Department Reports',
      actionCode: saveReport,
      path: departmentReportsDraftPath(scope, scopeId),
    });
  }

  const sendInvite = getScopedActionCode(scope, 'SEND_INVITE');
  if (permitted.has(sendInvite)) {
    actions.push({
      key: 'send-invite',
      label: 'Send Invitation',
      actionCode: sendInvite,
      path: invitesPath(scope, scopeId),
    });
  }

  return actions;
}

/** Action codes the dashboard needs for local quick actions. */
export function dashboardPermissionActionCodes(scope: string): string[] {
  const codes = [
    getScopedActionCode(scope, 'SAVE_REPORT'),
    getScopedActionCode(scope, 'SEND_INVITE'),
    getScopedActivityEntryCode(scope, 'save'),
    getScopedActivityEntryCode(scope, 'submit'),
    getScopedActivityEntryCode(scope, 'review'),
  ].filter(Boolean);

  return codes;
}
